import React, { useState } from "react";
import { debounce } from "lodash";
import Select from "react-select";

export default function ReactSelect({ data, isLoading, error, value, onChange, defaultValue, label, isMulti, isDisabled = false }) {
  const [selected, setSelected] = useState(value);

  const handleChange = (selectedOptions) => {
    setSelected(selectedOptions);
    onChange(selectedOptions);
  };

  return (
    <div className="flex flex-col">
      <label className="text-sm mb-2">
        {label} <span className="text-danger">*</span>
      </label>
      <Select
        placeholder="Cari..."
        defaultValue={defaultValue}
        options={data}
        aria-label="react-select"
        isClearable
        isSearchable={true}
        value={selected}
        onChange={handleChange}
        isMulti={isMulti}
        isLoading={isLoading}
        theme={(theme) => ({
          ...theme,
          borderRadius: 10,
          borderWidth: 4,
          colors: {
            ...theme.colors,
            primary25: "#EBF2F0",
          },
        })}
        styles={{
          menu: (styles) => ({ ...styles, zIndex: 999 }),
          control: (styles) => ({ ...styles, backgroundColor: "#EBF2F0" }),
          option: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
          placeholder: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
          multiValue: (styles) => ({ ...styles, backgroundColor: "#C7D2CF", borderRadius: 5 }),
          indicatorSeparator: (styles) => ({ ...styles, alignSelf: "stretch", marginBottom: 8, marginTop: 8, width: 2, backgroundColor: "#E1E8E6" }),
        }}
        isDisabled={isDisabled}
      />
      {error && <p className="text-danger text-xs">{error}</p>}
    </div>
  );
}
